<app-product-to-storage-place-list-widget
    [autoFocusSearch]="false"
    [productIdInputSig]="this.model.id"
></app-product-to-storage-place-list-widget>
